/* eslint-disable react/no-array-index-key */
import { useContext } from 'react';
import classNames from 'classnames';

import { TableContent } from 'types/Description';
import { ConfigContext } from '@providers/ConfigProvider';
import createStyleVariables from 'utils/createStyleVariables';

import { getDescription } from '../../Description.utils';
import classes from './Table.module.scss';

type Props = {
  rows: TableContent['content'];
  renderFakeHeaders: boolean;
  withBorders: boolean;
  width?: string;
};

const Table = ({ rows, renderFakeHeaders, withBorders, width }: Props): JSX.Element => {
  const { appUrl, contact } = useContext(ConfigContext);
  const cellHasWidth = rows[0].content.find((cell) => cell.attrs.colwidth?.[0]);

  return (
    <div className={classes.container}>
      <table
        className={classNames(classes.table, {
          [classes.layoutFixed]: !cellHasWidth,
          [classes.withBorders]: withBorders,
        })}
        style={createStyleVariables({ tableWidth: width ? `${width}px` : undefined })}
      >
        <tbody>
          {rows.map((row, i) => (
            <tr key={`tableRow-${i}`}>
              {row.content.map(({ attrs, content = [] }, j) => (
                <td
                  key={`tableCell-${j}`}
                  className={classes.td}
                  colSpan={attrs.colspan}
                  rowSpan={attrs.rowspan}
                  width={attrs.colwidth?.[0]}
                >
                  {getDescription({ appUrl, contact, content, renderFakeHeaders })}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
